"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPlayer = void 0;
exports.videoPlayer = {
    playIconBackdropSize: 84,
    playIconBackdropOpacity: 0.8,
};
